var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { StepEnum } from '../../../../../models/modules/lotteryplatofrm.models';
import { BrandingPreviewBase } from '../../branding/branding-preview-base';
import { EventAggregator } from 'aurelia-event-aggregator';
import { OverlayBrandingColors } from './overlay-steps/overlay/overlay-branding-colors';
import { OverlayBrandingImages } from './overlay-steps/overlay/overlay-branding-images';
import { OverlayBrandingText } from './overlay-steps/overlay/overlay-branding-text';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService, TemplateType } from '../../../../../services/modules/brand-client.service';
import { AttachmentClientService } from '../../../../../services/modules/attachements-client.service';
import { OverlayBrandingFeatured } from './overlay-steps/overlay/overlay-branding-featured';
import { CacheClient } from '../../../../../services/basics/client-caching.service';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import * as Enumerable from "linq";
import { JsonLockClientService } from '../../../../../services/modules/json-lock-client-service';
var OverlayBrandingDialog = /** @class */ (function (_super) {
    __extends(OverlayBrandingDialog, _super);
    function OverlayBrandingDialog(element, notificationService, i18N, eventAggregator, lotteryClientService, brandClientService, attachmentClientService, overlayBrandingText, overlayBrandingImages, overlayBrandingColors, overlayBrandingFeatured, cacheClient, tokenClientService, lookupClientService, dialogClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.overlayBrandingText = overlayBrandingText;
        _this.overlayBrandingImages = overlayBrandingImages;
        _this.overlayBrandingColors = overlayBrandingColors;
        _this.overlayBrandingFeatured = overlayBrandingFeatured;
        return _this;
    }
    OverlayBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Overlay];
    };
    OverlayBrandingDialog.prototype.getBrandTemplateInternalName = function () {
        return this.item.template.internalName;
    };
    OverlayBrandingDialog.prototype.getBrandThemeInternalName = function () {
        return this.item.brandTheme ? this.item.brandTheme.internalName : null;
    };
    OverlayBrandingDialog.prototype.getBrandingSteps = function () {
        var _this = this;
        return [{
                title: this.i18N.tr('overlay'),
                step: StepEnum.OverlayBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr('overlay-branding-text'),
                        vm: this.overlayBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/overlay-steps/overlay/overlay-branding-text.html'
                    },
                    {
                        title: this.i18N.tr('overlay-branding-images'),
                        vm: this.overlayBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/overlay-steps/overlay/overlay-branding-images.html'
                    },
                    {
                        title: this.i18N.tr('overlay-branding-colors'),
                        vm: this.overlayBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/overlay-steps/overlay/overlay-branding-colors.html'
                    },
                    {
                        title: this.i18N.tr('overlay-branding-featured'),
                        vm: this.overlayBrandingFeatured,
                        show: true,
                        view: '../../app/admin/brand/dialogs/overlay-steps/overlay/overlay-branding-featured.html'
                    }
                ],
                onClick: function (x) {
                    _this.reloadPreview();
                }
            }];
    };
    OverlayBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.brandId,
            brandName: this.item.name,
            brandLanguages: Enumerable.from(this.item.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    OverlayBrandingDialog.prototype.getRoute = function () {
        return "";
    };
    OverlayBrandingDialog.prototype.isOverlay = function () {
        return true;
    };
    OverlayBrandingDialog.prototype.getImages = function () {
        var items = [
            this.overlayBrandingImages.model
        ];
        return items;
    };
    OverlayBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator, LotteryClientService,
            BrandClientService, AttachmentClientService,
            OverlayBrandingText,
            OverlayBrandingImages,
            OverlayBrandingColors,
            OverlayBrandingFeatured,
            CacheClient,
            TokenClient, LookupClientService, DialogClientService, JsonLockClientService])
    ], OverlayBrandingDialog);
    return OverlayBrandingDialog;
}(BrandingPreviewBase));
export { OverlayBrandingDialog };
